<template>
  <div v-loading="loading" style="width: 100%; height: 100vh; display: flex; align-items: center; justify-content: center;">
    <el-button @click="open" type="primary" v-if="path">打开文件</el-button>
  </div>
</template>

<script>
import { increasedGetPath } from '@/api/increased'
export default {
  data() {
    return {
      loading: false,
      path: ''
    }
  },
  created() {
    if (!this.$route.query.code && !this.$route.query.id) {
      this.$router.replace({ path: '/login' })
    } else {
      this.loading = true
      increasedGetPath({ code: this.$route.query.code, id: this.$route.query.id }).then(res => {
        this.loading = false
        if (res.code == '000') {
          if (res.result) {
            // this.path = 'http://10.108.1.124:8000/api/system/static/' + res.result.id
            this.path = '/api/system/static/' + res.result.id
            const link = document.createElement('a')
            link.href = this.path // 替换为你的PDF文件路径
            link.click()
          } else {
            this.$message.error('无效二维码，请重新扫码')
          }
        }
      })
    }
  },
  methods: {
    open() {
      window.open(this.path)
    }
  }
}
</script>
